<template>
    <div class="loadable | relative flex-1 overflow-y-auto" :class="{ 'loading': loading }">
        <div class="p-8">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            loading: {
                type: Boolean,
                default: false,
            },
        },
    };
</script>
